<script>
  import { getAddress } from "viem";
  import { readContract, writeContract } from "@wagmi/core";

  import { chainExplorer, walletAddress } from "../stores.js";
  import { getABI } from "../utils.js";

  /** @type {number} */
  export let chain;
  /** @type {string} */
  export let address;
  /** @type {string} */
  export let queue_url;
  /** @type {boolean} */
  export let notAutomatic = true;

  const frequencies = [ 'AsTheyCome', 'Hourly', 'Daily', 'Weekly', 'Monthly', 'Yearly' ];

  let abi;
  let frequency;
  let trigger;

  let paying = false;
  let txHash;
  let feedback;

  let show = false;

  $: $walletAddress, init();

  const init = async () => {
    if ($walletAddress) {
      abi = await getABI(address, chain);
      try {
        await readContract({ address, abi, functionName: 'checkRestrictions', args: [ $walletAddress, 0 ] });
      } catch (err) {
        if (err.cause?.reason === 'Needs to be queued') {
          const freq = await readContract({ address, abi, functionName: 'frequency' });
          frequency = frequencies[freq];
        } else {
          console.log(err)
        }
      }
      trigger = await readContract({ address, abi, functionName: 'trigger' });
      if (frequency < 2 && !notAutomatic) {
        await pay();
      }
    }
  }

  const pay = async () => {
    paying = true;
    if (frequency) {
      const resp = await fetch(`${ queue_url }/add/to/${ frequency.toLowerCase() }/${ chain }/${ getAddress(address) }/${ $walletAddress }`);
      feedback = await resp.json();
      setTimeout(() => { feedback = undefined; }, 5000);
    } else {
      try {
        const { hash } = await writeContract({ address, abi, functionName: 'send', args: [ $walletAddress ] });
        txHash = hash;
      } catch (err) {
        if (err.shortMessage === 'User rejected the request.') {
          dispatch('user-cancel');
          new CustomEvent('user-cancel');
        } else {
          console.log(err)
          dispatch('error', err);
          new CustomEvent('error', { detail: err });
        }
        paying = false;
        return;
      }

      dispatch('hashed', txHash);
      new CustomEvent('hashed', { detail: txHash });
      const receipt = await getPublicClient().waitForTransactionReceipt({ hash: txHash });
      dispatch('paid', receipt)
      new CustomEvent('paid', { detail: receipt });
      feedback = 'Paid!';
      setTimeout(() => { feedback = undefined; }, 5000);
      txHash = undefined;
      paying = false;
    }
  }
</script>

<div class="lt-faucet">
  {#if !trigger}
    <div class="loading">Loading...</div>
  {:else if feedback}
    <div class="feedback">{ feedback }</div>
  {:else if txHash}
    <a href="{ $chainExplorer.url }/tx/{ txHash }" class="tx">View tx</a>
  {:else}
    {#if trigger[0] === 0}
      <span class="auto">Automatically triggered</span>
    {:else if trigger[0] === 1}
      <img src={ trigger[1] } alt="Trigger" width="100px" class="img" />
    {:else if trigger[0] === 2}
      youtube
    {:else if trigger[0] === 3}
      <button type="button" class="btn" on:click={ pay }>
        {#if paying}
          <span class="btn-loading"></span>
        {/if}
        { trigger[1] }
      </button>
    {:else}
      <ifame title="Trigger" width="100px" src={ trigger[1] } class="iframe"></ifame>
    {/if}
  {/if}
</div>